import {
  getCountryDefinition,
  isIso3166Alpha2Lower,
} from "../country/country-definitions";
import { getDefaultLocaleCode, getDomain } from "./locale-registry";

/**
 * Maps an ISO 3166-1 alpha-2 country code to a registered site domain.
 * Falls back to the default locale domain when the code is missing or unknown —
 * used when building preview URLs from CMS address country fields.
 */
function getSiteIdFromCountryCode(country: string | undefined): string {
  if (!country) {
    return getDomain(getDefaultLocaleCode());
  }

  const iso3166Alpha2Lower = country.toLowerCase();
  if (!isIso3166Alpha2Lower(iso3166Alpha2Lower)) {
    return getDomain(getDefaultLocaleCode());
  }

  return getCountryDefinition(iso3166Alpha2Lower).domain;
}

export { getSiteIdFromCountryCode };
